import React from 'react';
import {Typography} from '@mui/material';
import {t} from 'i18next';
import AurButton from '../aur-button/AurButton';
import AurBreadcrumb from '../aur-breadcrumb/AurBreadCrumb';

/**
 * Define the props interface for the AurPageHeader component
 * isSecondaryButton => Optional prop to conditionally render a secondary button
 * heading => Required prop for the heading text
 */
interface IAurHeader {
  isSecondaryButton?: boolean;
  heading: string;
  linkLabel?: string;
  ariaLabel?: string;
  tabIndex?: number;
  selectedClientName?: string;
  onButtonClick?: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
  onLinkCLick?: (
    event?: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => void;
  className?: string;
  hideHeader?: boolean;
  path?: string;
  onBreadcrumbLinkClick?: (
    event?: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => void;
}
// Define the AurPageHeader functional component with Props as its type
const AurPageHeader: React.FC<IAurHeader> = (props: IAurHeader) => {
  // Provide a default value of false for isSecondaryButton if not provided
  const {
    isSecondaryButton = false,
    heading,
    linkLabel,
    onButtonClick,
    ariaLabel,
    tabIndex,
    selectedClientName,
    className = '',
    path = '/clients',
    onBreadcrumbLinkClick,
    hideHeader = false,
  } = props;

  return (
    <div className={`AurHeader ${className}`}>
      <div className="client-details-bread-crumb-container">
        <AurBreadcrumb
          items={[
            {
              label: linkLabel ?? '',
              path,
              onClick: () => {
                onBreadcrumbLinkClick?.();
              },
            },
            {label: t('clientDetailsPage.clientDetails')},
          ]}
        />
      </div>

      <Typography className="typo-text subhead3_size _size mist_100 custom-margin">
        {selectedClientName}
      </Typography>
      <div className="AurHeader_heading-container">
        {!hideHeader && (
          <Typography
            variant="h1"
            component="h1"
            aria-label={ariaLabel}
            tabIndex={tabIndex}
            className="typo-text headline1_size mist-color-100"
          >
            {heading}
          </Typography>
        )}
        {isSecondaryButton && (
          <AurButton
            classNames="AurHeader_start-over-button"
            type="exit"
            label={t('buttons.startOver')}
            onClick={onButtonClick}
          />
        )}
      </div>
    </div>
  );
};

export default AurPageHeader;
